export const URL_GET_CALL_HISTORY = '/v1/pos/call/site/call-history';